export const diffDates = (day_one, day_two) => {
  return Math.ceil((day_one - day_two) / (60 * 60 * 24 * 1000));
};
